import React from "react";
import PropTypes from "prop-types";
import { Star } from "lucide-react";
import { cn } from "../../utils/classNames";

const RatingBadge = React.forwardRef(
  ({ variant = "rating", children, className, ...props }, ref) => {
    const variants = {
      rating: "bg-primary text-primary-foreground border border-primary",
      new: "bg-background/90 text-foreground border border-foreground/10",
      unrated: "bg-muted text-muted-foreground border border-border",
    };

    return (
      <span
        ref={ref}
        className={cn(
          "shrink-0 flex items-center gap-1 px-2 py-1 rounded-md text-badge-count whitespace-nowrap",
          variants[variant],
          className
        )}
        {...props}
      >
        {variant === "rating" && <Star className="h-3 w-3 fill-current" />}
        {variant === "unrated" && <Star className="h-3 w-3" />}
        {children}
      </span>
    );
  }
);

RatingBadge.displayName = "RatingBadge";

RatingBadge.propTypes = {
  variant: PropTypes.oneOf(["rating", "new", "unrated"]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default RatingBadge;
